<button type="button"
        [disabled]="isDisabled"
        class="ace-btn btn-sm btn-primary"
        title="Edit linked parcels"
        (click)="edit()">
    Link Parcels
</button>
